import React, { Component } from 'react';
import DateTime from 'react-datetime';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import ContentLoader from 'components/common/loaders/ContentLoader';
import moment from 'moment';

export default class MonthCalendar extends Component {
  static propTypes = {
    appointmentList: PropTypes.array.isRequired,
    fetchMonthAppointments: PropTypes.func,
    changeMonthActiveDate: PropTypes.func,
    currentDate: PropTypes.object,
    activeDate: PropTypes.object
  }

  constructor (props) {
    super(props);
    this.state = {
      currMonth: moment(get(props, 'currentDate', null)).startOf('month'),
      currYear: moment(get(props, 'currentDate', null)).startOf('year'),
      isLoading: false
    };
  }

  hasAppointments = (currDate) => {
    const { appointmentList } = this.props;
    if (!Array.isArray(appointmentList)) { return false; }
    const appointmentDates = appointmentList.map(appt => moment(appt.startDate).format('YYYY/MM/DD'));
    return currDate && appointmentDates.indexOf(currDate.format('YYYY/MM/DD')) !== -1;
  }

  onDayClick = (ev, props, currentDate, selectedDate) => {
    if (props.className.indexOf('rdtNew') === -1 && props.className.indexOf('rdtOld') === -1) { props.onClick(ev); }
  }

  renderDay = (props, currentDate, selectedDate) => {
    let tileClassName = '';
    const indicatorStyle = {};

    if (props.className.indexOf('rdtActive') !== -1) { tileClassName += ' rdt-active-circle'; }

    if (props.className.indexOf('rdtToday') !== -1) { tileClassName += ' rdt-today-circle'; }

    indicatorStyle.background = this.hasAppointments(currentDate) ? 'black' : 'none';
    return <td {...props} onClick={(ev) => this.onDayClick(ev, props, currentDate, selectedDate)}>
      <div className={'tile-day-circle' + tileClassName}>
        <span className='tile-day-text'>{currentDate.date()}</span>
      </div>
      <div style={indicatorStyle} className='tile-indicator' />
    </td>;
  }

  onMonthClick = async (ev, props, monthMoment) => {
    this.setState({ isLoading: true });
    props.onClick(ev);
    this.setState({ currMonth: monthMoment, currYear: moment(monthMoment).startOf('year'), isLoading: false });
    await this.props.fetchMonthAppointments(moment(this.state.currYear).month(monthMoment.month()).startOf(monthMoment));
  }

  renderMonth = (props, month) => {
    const monthMoment = moment(this.state.currYear).month(month).startOf('month');
    return <td {...props} onClick={(ev) => this.onMonthClick(ev, props, monthMoment)}>{monthMoment.format('MMM').toUpperCase()}</td>;
  }

  onYearClick = (ev, props, yearMoment) => {
    props.onClick(ev);
    this.setState({ currYear: yearMoment });
  }

  renderYear = (props, year) => {
    const yearMoment = moment(this.state.currYear).year(year).startOf('year');
    return <td {...props} onClick={(ev) => this.onYearClick(ev, props, yearMoment)}>{year}</td>;
  }

  handleDateChange = (changedMoment) => {
    this.props.changeMonthActiveDate(changedMoment);
  }

  navigateBack = async (value, type) => {
    if (type === 'months') {
      const currMonth = moment(this.state.currYear.month(this.state.currMonth.month())).startOf('month');
      this.setState({ isLoading: true });
      await this.props.fetchMonthAppointments(currMonth.subtract(1, 'months').startOf('month'));
      this.setState({ currMonth: currMonth, currYear: moment(currMonth).startOf('year'), isLoading: false });
    }

    if (type === 'years') {
      const currYear = moment(this.state.currYear).startOf('year');
      this.setState({ currYear: currYear.subtract(1, 'year').startOf('year') });
    }
  }

  navigateForward = async (value, type) => {
    if (type === 'months') {
      const currMonth = moment(this.state.currYear.month(this.state.currMonth.month())).startOf('month');
      this.setState({ isLoading: true });
      await this.props.fetchMonthAppointments(currMonth.add(1, 'months').startOf('month'));
      this.setState({ currMonth: currMonth, currYear: moment(currMonth).startOf('year'), isLoading: false });
    }

    if (type === 'years') {
      const currYear = moment(this.state.currYear).startOf('year');
      this.setState({ currYear: currYear.add(1, 'year').startOf('year') });
    }
  }

  render () {
    const currYear = this.state.currYear;
    const currMonth = this.state.currMonth;
    let defaultDate = true;
    if (!this.props.activeDate && currMonth && currMonth.month() === moment().month() && currYear && currYear.year() === moment().year()) {
      defaultDate = false;
    }
    return (
      this.state.isLoading
        ? <ContentLoader isLoading={this.state.isLoading} />
        : <DateTime className='monthview-calendar'
          value={this.props.activeDate || (defaultDate ? moment(currYear).month(currMonth.month()).startOf('month') : moment())}
          timeFormat={false}
          input={false}
          renderDay={this.renderDay}
          renderMonth={this.renderMonth}
          renderYear={this.renderYear}
          onChange={this.handleDateChange}
          locale={'en-US'}
          onNavigateBack={this.navigateBack}
          onNavigateForward={this.navigateForward}
        />
    );
  }
}
